import { AccountDetails } from './AccountDetails';
import { Packages } from './Packages';
import { Devices } from './Devices';
import { CheckCircle } from '@material-ui/icons';
import { Checkbox } from '../../../components/Checkbox';

export const Review = (props: CreateAccountReviewProps) => {
  const {
    canCreateAccount,
    formValues,
    formActive,
    onChange,
    onReviewed,
    optionMenus,
    reviewed,
    updateFormState,
  } = props;

  return (
    <div className="relative flex flex-col gap-2 p-4">
      {reviewed ? (
        <CheckCircle className="absolute top-0 right-0 text-success" />
      ) : null}
      <p className="text-lg">Account Details</p>
      <AccountDetails
        asReview
        formActive={formActive}
        formValues={formValues}
        onChange={(value, name) => onChange(value, name)}
        optionMenus={optionMenus}
        updateFormState={updateFormState}
      />
      <p className="text-lg">Packages</p>
      <Packages
        asReview
        formActive={formActive}
        formValues={formValues}
        optionMenus={optionMenus}
        updateFormState={updateFormState}
      />
      {formValues.devices.length ? (
        <>
          <p className="text-lg">Devices</p>
          <Devices
            asReview
            formActive={formActive}
            formValues={formValues}
            updateFormState={updateFormState}
          />
        </>
      ) : null}

      <div className="flex items-center justify-center gap-2">
        {canCreateAccount ? (
          <Checkbox
            label="I have reviewed all account information"
            color="primary"
            checked={reviewed}
            onChange={() => onReviewed(!reviewed)}
          />
        ) : (
          <p className="text-center text-error">
            *Required information is missing
          </p>
        )}
      </div>
    </div>
  );
};
